import {
  SyncErrorIcon,
  WeatherLgRainV2,
  WeatherRainIcon,
} from '@/components/icons'
import useCheckOverlay from '@/features/admin/hooks/locationInterface/useCheckOverlay'
import { useAuthContext } from '@/features/auth/context'
import classes from '@/features/config/components/common/style.module.scss'
import NotificationModal from '@/features/config/components/modal/NotificationModal'
import useSearchFlowValveError from '@/features/config/hooks/hydraulic/flowValve/useSearchFlowValveError'
import { useSearchStation } from '@/features/operations/hooks/station'
import { useTranslation } from '@/hooks/useTranslation'
import { Box, Dialog, Stack, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import useGetDetailWaterEngine from '@/features/config/hooks/waterengine/useGetDetailWaterEngine'

interface ModalProps {
  sx?: any
  interfaceShowing?: number | null
  rainingSX?: any
  isSetupPage?: boolean
}

const ErrorPage = (props: ModalProps) => {
  const { t } = useTranslation()
  let { interfaceId } = useAuthContext()
  interfaceId = props.interfaceShowing || interfaceId
  const location = useLocation()
  const searchParams = {
    PageSize: 0,
  }
  const { data } = useSearchStation(searchParams, Number(interfaceId || 0))

  const { data: dataFlowValveError } = useSearchFlowValveError(
    Number(interfaceId || 0),
    searchParams,
  )

  const { data: dataWaterEngine } = useGetDetailWaterEngine(
    Number(interfaceId || 0),
    {
      enabled: !props.isSetupPage && !!Number(interfaceId || 0),
      refetchInterval: 120000,
      refetchIntervalInBackground: true,
    },
  )

  useEffect(() => {
    console.log(dataFlowValveError)
  }, [dataFlowValveError])

  const { data: errorOverlay } = useCheckOverlay(interfaceId)

  const [open, setOpen] = useState(false)

  const listStation = (array: any) => {
    const arrayArea = []

    for (const id of array) {
      if (0 !== id.errorCode) {
        arrayArea.push(id)
      }
    }

    return arrayArea
  }

  const isDashboardOrConfig = ['dashboard', 'config'].includes(
    location.pathname.split('/')[1],
  )
  const listErStation =
    data && isDashboardOrConfig ? listStation(data?.list || []) : []

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      {dataWaterEngine?.state == 4 && (
        <Box
          component="span"
          sx={props.rainingSX}
          className={classes.txtBoxRaining}
        >
          <WeatherLgRainV2 /> {t('commonLabelRaining')}
        </Box>
      )}
      <Stack
        className={classes.txtPos}
        spacing={3}
        direction="row"
        onClick={() => handleClickOpen()}
        sx={props.sx}
      >
        {(listErStation.length > 0 ||
          (dataFlowValveError && dataFlowValveError?.list.length > 0)) && (
          <Box
            component="span"
            className={classes.txtBox}
            sx={props.interfaceShowing ? { width: '83px' } : { width: '83px' }}
          >
            <WarningAmberIcon /> {t('errorsNotificationsErrors')}
          </Box>
        )}

        {(listErStation.length > 0 ||
          (dataFlowValveError && dataFlowValveError?.list.length > 0)) && (
          <Stack className={classes.txtCount}>
            <Typography
              sx={{
                color: '#FFFFFF',
                fontSize: '10px',
                p: '2px',
                textAlign: 'center',
              }}
            >
              {listErStation.length + (dataFlowValveError?.list?.length ?? 0)}
            </Typography>
          </Stack>
        )}
      </Stack>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={false}
        PaperProps={{
          sx: { width: '90vw', maxWidth: '1400px', m: 2 },
        }}
      >
        <NotificationModal
          data={listErStation}
          dataFlowValve={dataFlowValveError}
          interfaceShowing={props.interfaceShowing}
          onClose={handleClose}
        />
      </Dialog>
    </>
  )
}

export default ErrorPage
